// deps
import { useRef } from "react";
import { useButton } from "@react-aria/button";
import { Button as ChakraButton } from "@chakra-ui/react";

function FieldButton(props) {
  let ref = useRef(null);
  let { buttonProps } = useButton(props, ref);
  return (
    <ChakraButton {...buttonProps} ref={ref} size="sm" h="1.75rem" mr="2">
      {props.children}
    </ChakraButton>
  );
}

export default FieldButton;
